
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lighting-retrofit/project-intro",
      function () {
        return require("private-next-pages/lighting-retrofit/project-intro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lighting-retrofit/project-intro"])
      });
    }
  